export default "__VITE_ASSET__DCQ07uZz__"